{
  "v5.architecture.annuler": "Cancel",
  "v5.architecture.annuler.bouton": "Confirm the cancellation",
  "v5.architecture.annuler.rappel": "{{numero}} — {{titre}} will be cancelled; the reason is kept.",
  "v5.architecture.annuler.titre": "Cancel an architecture decision",
  "v5.architecture.arc.ajoutes": "{{section}} added: {{liste}}",
  "v5.architecture.arc.aucun_ecart": "No difference: both references are identical.",
  "v5.architecture.arc.bouton_comparer": "Compare",
  "v5.architecture.arc.bouton_figer": "Freeze the baseline",
  "v5.architecture.arc.cible": "Compare with",
  "v5.architecture.arc.cible_ligne": "Baseline “{{nom}}”",
  "v5.architecture.arc.cible_version": "State of version {{version}}",
  "v5.architecture.arc.comparer_titre": "Compare",
  "v5.architecture.arc.ecarts": "Differences",
  "v5.architecture.arc.ecarts_libelle": "the differences",
  "v5.architecture.arc.ecarts_vide": "Choose two references, then compare.",
  "v5.architecture.arc.figee": "Baseline “{{nom}}” frozen (timestamp without legal value).",
  "v5.architecture.arc.figer": "Freeze a baseline",
  "v5.architecture.arc.ligne_auteur": "Frozen by",
  "v5.architecture.arc.ligne_date": "On",
  "v5.architecture.arc.ligne_nom": "Name",
  "v5.architecture.arc.ligne_reference": "Baseline",
  "v5.architecture.arc.ligne_version": "Version",
  "v5.architecture.arc.lignes": "Baselines",
  "v5.architecture.arc.lignes_libelle": "the baselines",
  "v5.architecture.arc.lignes_vide": "No baseline frozen.",
  "v5.architecture.arc.modifies": "{{section}} changed: {{liste}}",
  "v5.architecture.arc.nom_ligne": "Baseline name",
  "v5.architecture.arc.ouvrir": "Open the version architecture",
  "v5.architecture.arc.perimetre": "Scope",
  "v5.architecture.arc.perimetre.architecture": "Version architecture (components, dependencies, technologies)",
  "v5.architecture.arc.references": "References to compare",
  "v5.architecture.arc.retires": "{{section}} removed: {{liste}}",
  "v5.architecture.arc.section.composants": "Components",
  "v5.architecture.arc.section.dependances": "Dependencies",
  "v5.architecture.arc.section.technologies": "Technologies",
  "v5.architecture.arc.titre": "Architecture of the delivered application",
  "v5.architecture.arc.version": "Delivered version",
  "v5.architecture.arc.version_a_figer": "Version to freeze",
  "v5.architecture.arc.version_option": "{{version}} — {{composants}} components",
  "v5.architecture.arc.versions": "Delivered versions",
  "v5.architecture.arc.versions_libelle": "the delivered versions",
  "v5.architecture.arc.versions_vide": "No delivered version in this project.",
  "v5.architecture.champ.contexte": "Context",
  "v5.architecture.champ.motif": "Reason",
  "v5.architecture.champ.probleme": "Problem",
  "v5.architecture.champ.probleme_aide": "Stored in the context, “Problem” section.",
  "v5.architecture.champ.sujet": "Subject",
  "v5.architecture.champ.titre": "Title",
  "v5.architecture.code.ACCESS_REQUEST_ALREADY_MEMBER": "You are already a project member.",
  "v5.architecture.code.ACCESS_REQUEST_ALREADY_PENDING": "A request is already pending.",
  "v5.architecture.code.ACCESS_REQUEST_NOT_MEMBER": "A right extension requires being a project member.",
  "v5.architecture.code.ACCESS_REQUEST_RIGHT_ALREADY_HELD": "You already hold this right.",
  "v5.architecture.code.ADR_ALREADY_REVIEWED": "Already reviewed: a new review follows a new revision.",
  "v5.architecture.code.ADR_ANNULATION_HORS_ETAT": "Only a decision being prepared or decided can be cancelled.",
  "v5.architecture.code.ADR_DECIDED_IMMUTABLE": "Decision already decided: it can no longer change.",
  "v5.architecture.code.ADR_ISSUE_MOTIF_REQUIS": "Without a chosen option, the reason is required.",
  "v5.architecture.code.ADR_NUMBER_EXISTS": "This decision number already exists in the project.",
  "v5.architecture.code.ADR_REVIEWER_CANNOT_DECIDE": "Whoever reviewed the decision does not decide it.",
  "v5.architecture.code.ADR_SELF_DECISION_REFUSED": "The author does not decide their own decision.",
  "v5.architecture.code.ADR_SELF_REVIEW_REFUSED": "The author does not review their own decision.",
  "v5.architecture.code.ADR_SUPERSEDE_NOT_DECIDED": "Replacement impossible: both decisions must be decided.",
  "v5.architecture.code.ADR_TRIANGLE_REVIEW_REQUIRED": "Hard-to-reverse decision: a separate favourable review is required.",
  "v5.architecture.code.ADR_WEIGHTS_FROZEN": "Criteria frozen since the first score.",
  "v5.architecture.code.CONTEXTE_INCOMPLET": "The project context is incomplete: the action is refused.",
  "v5.architecture.code.CREATEUR_N_APPROUVE_PAS": "Separation of duties: the author does not approve their own work.",
  "v5.architecture.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v5.architecture.code.GARDE_DROIT_ABSENTE": "This operation has no right guard: refused by default.",
  "v5.architecture.code.LIGNE_DE_BASE_INTROUVABLE": "Baseline not found in this project.",
  "v5.architecture.code.LIGNE_DE_BASE_NOM_DEJA_UTILISE": "This baseline name is already used in the project.",
  "v5.architecture.code.MODELE_V10_INCOHERENT": "The project model is inconsistent: the screen cannot be shown.",
  "v5.architecture.code.NOT_FOUND": "Not found in this project.",
  "v5.architecture.code.RELEASE_NOT_FOUND": "Version not found in this project.",
  "v5.architecture.code.RELECTEUR_NE_DECIDE_PAS": "Separation of duties: whoever reviewed does not decide.",
  "v5.architecture.code.REPRISE_PREUVE_MANQUANTE": "Validation impossible: an expected evidence is missing.",
  "v5.architecture.code.RESOURCE_UNAVAILABLE": "Decision not found in this project.",
  "v5.architecture.code.SANS_SESSION": "Session expired: sign in again.",
  "v5.architecture.code.TECH_BASELINE_CHANGE_REQUIRED": "This category is set by the baseline: go through a technology change.",
  "v5.architecture.code.TECH_CHANGE_REWORK_OPEN": "Rework items remain to be done.",
  "v5.architecture.code.VALIDATION_ERROR": "The input is incomplete or invalid.",
  "v5.architecture.code.WORKSPACE_ARCHIVED": "The project is archived: read only.",
  "v5.architecture.composant.aucun": "No component designated.",
  "v5.architecture.composant.depend": "Depends on: {{liste}}",
  "v5.architecture.composant.entete": "{{nom}} ({{nature}})",
  "v5.architecture.composant.fichiers": "Files",
  "v5.architecture.composant.libelle": "the component",
  "v5.architecture.composant.lignes": "Lines",
  "v5.architecture.composant.relations": "Component relations",
  "v5.architecture.composant.retour": "Back to the version architecture",
  "v5.architecture.composant.routes": "Routes",
  "v5.architecture.composant.sans_relation": "No relation found.",
  "v5.architecture.composant.technologie": "Technology",
  "v5.architecture.composant.titre": "Component of a delivered version",
  "v5.architecture.composant.utilise_par": "Used by: {{liste}}",
  "v5.architecture.creer.bouton": "Create the decision",
  "v5.architecture.creer.titre": "Create an architecture decision",
  "v5.architecture.decider.auteur": "Prepared by {{auteur}}: decided by someone else.",
  "v5.architecture.decider.bouton": "Confirm the decision",
  "v5.architecture.decider.commentaire": "Decision comment",
  "v5.architecture.decider.commentaire_requis": "Comment required (reason when no option is chosen).",
  "v5.architecture.decider.deja": "This decision can no longer be decided.",
  "v5.architecture.decider.issue": "Outcome",
  "v5.architecture.decider.issue.aucune_option": "No option is chosen",
  "v5.architecture.decider.issue.option_retenue": "An option is chosen",
  "v5.architecture.decider.option": "Chosen option",
  "v5.architecture.decider.recapitulatif": "Summary",
  "v5.architecture.decider.relecteur": "Whoever reviewed this decision does not decide it.",
  "v5.architecture.decider.sans_option": "No option to choose: only the “no option” outcome is possible.",
  "v5.architecture.decider.titre": "Confirm the architecture decision",
  "v5.architecture.droit.a_preciser": "No right is designated: come back from the greyed element that needs it.",
  "v5.architecture.droit.circuit": "Approval path",
  "v5.architecture.droit.circuit_aucun": "No project profile grants this right: the request cannot succeed.",
  "v5.architecture.droit.circuit_chargement": "Looking for the profiles that grant this right…",
  "v5.architecture.droit.circuit_non_divulguable": "The profiles that grant this right are not disclosed.",
  "v5.architecture.droit.circuit_profils": "Granted by an authorised person: {{profils}}.",
  "v5.architecture.droit.doublon": "A request for this right is already pending.",
  "v5.architecture.droit.duree": "Duration",
  "v5.architecture.droit.duree_texte": "Permanent until withdrawn by an authorised person; you never grant it to yourself.",
  "v5.architecture.droit.effet.immediat": "No right is granted until an authorised person decides.",
  "v5.architecture.droit.effet.separation": "Separation of duties always applies, even once the right is granted.",
  "v5.architecture.droit.effet.suivi": "You follow your request from “Project access”.",
  "v5.architecture.droit.effets": "Effects",
  "v5.architecture.droit.envoyer": "Send the request",
  "v5.architecture.droit.extension": "Right extension: you remain a project member with your current profiles.",
  "v5.architecture.droit.identifie": "Requested right: {{libelle}}",
  "v5.architecture.droit.motif_aide": "Say why you need this right.",
  "v5.architecture.droit.portee": "Request scope",
  "v5.architecture.droit.portee_libelle": "your pending requests",
  "v5.architecture.droit.requis": "Required right",
  "v5.architecture.droit.titre": "Request an additional right",
  "v5.architecture.editeur.ajouter_critere": "Add the criterion",
  "v5.architecture.editeur.ajouter_option": "Add the option",
  "v5.architecture.editeur.critere": "Criterion",
  "v5.architecture.editeur.critere_de_note": "Scored criterion",
  "v5.architecture.editeur.critere_libelle": "Criterion label",
  "v5.architecture.editeur.criteres": "Criteria",
  "v5.architecture.editeur.donnees": "Decision data",
  "v5.architecture.editeur.echoue": "Failed (option excluded)",
  "v5.architecture.editeur.enregistre": "Decision saved.",
  "v5.architecture.editeur.enregistrer": "Save",
  "v5.architecture.editeur.enregistrer_note": "Save the score",
  "v5.architecture.editeur.enregistrer_poids": "Save the weight",
  "v5.architecture.editeur.exclue": "Excluded: {{motif}}",
  "v5.architecture.editeur.figee": "This decision is no longer being prepared: read it from its record.",
  "v5.architecture.editeur.figes": "Criteria frozen since the first score.",
  "v5.architecture.editeur.incomplete": "Scores incomplete",
  "v5.architecture.editeur.justification": "Justification",
  "v5.architecture.editeur.matrice": "Options, criteria and scores",
  "v5.architecture.editeur.nature": "Criterion kind",
  "v5.architecture.editeur.nature.mandatory": "Mandatory, passed or failed",
  "v5.architecture.editeur.nature.weighted": "Weighted, scored from 1 to 5",
  "v5.architecture.editeur.note": "Score (1 to 5)",
  "v5.architecture.editeur.note_hors_bornes": "A score goes from 1 to 5.",
  "v5.architecture.editeur.notes": "Scores",
  "v5.architecture.editeur.nouveau_poids": "New weight",
  "v5.architecture.editeur.option_a_noter": "Option to score",
  "v5.architecture.editeur.option_description": "Option description",
  "v5.architecture.editeur.option_libelle": "Option label",
  "v5.architecture.editeur.options": "Options",
  "v5.architecture.editeur.poids_initial": "Initial weight",
  "v5.architecture.editeur.retour": "Back to the record",
  "v5.architecture.editeur.reussi": "Passed",
  "v5.architecture.editeur.sans_option": "No option yet.",
  "v5.architecture.editeur.score": "Weighted score",
  "v5.architecture.editeur.titre": "Prepare an architecture decision",
  "v5.architecture.editeur.total_poids": "Total of weighted weights: {{total}} (expected: 100)",
  "v5.architecture.editeur.verdict": "Verdict",
  "v5.architecture.etat.chargement": "Loading {{quoi}}…",
  "v5.architecture.etat.erreur": "{{quoi}}: cannot be read right now.",
  "v5.architecture.etat.reessayer": "Retry",
  "v5.architecture.etat.refus": "{{quoi}}: reading refused.",
  "v5.architecture.fermer": "Close",
  "v5.architecture.fiche.annulation": "Cancelled by {{par}} on {{date}}: {{motif}}",
  "v5.architecture.fiche.annuler": "Cancel the decision…",
  "v5.architecture.fiche.aucune_option": "No option chosen: {{motif}}",
  "v5.architecture.fiche.auteur": "Prepared by {{auteur}} on {{date}}",
  "v5.architecture.fiche.contexte": "Context",
  "v5.architecture.fiche.decider": "Decide…",
  "v5.architecture.fiche.decideur": "Decided by {{par}} on {{date}}",
  "v5.architecture.fiche.issue": "Chosen option and outcome",
  "v5.architecture.fiche.libelle": "the architecture decision",
  "v5.architecture.fiche.option_retenue": "Chosen option: {{option}}",
  "v5.architecture.fiche.preparer": "Prepare",
  "v5.architecture.fiche.remplace": "Supersedes {{numero}}",
  "v5.architecture.fiche.remplacee_par": "Superseded by {{numero}}",
  "v5.architecture.fiche.remplacement_motif": "Replacement reason: {{motif}}",
  "v5.architecture.fiche.remplacer": "Replace…",
  "v5.architecture.fiche.retour_liste": "Back to the decisions",
  "v5.architecture.fiche.revoir": "Review",
  "v5.architecture.fiche.revue": "Round {{tour}} — {{relecteur}}: {{verdict}}",
  "v5.architecture.fiche.revues": "Reviews",
  "v5.architecture.fiche.sans_issue": "No option chosen yet.",
  "v5.architecture.fiche.sans_predecesseur": "No predecessor",
  "v5.architecture.fiche.sans_remplacement": "Not superseded",
  "v5.architecture.fiche.sans_revue": "No review yet.",
  "v5.architecture.fiche.sujet": "Subject: {{sujet}}",
  "v5.architecture.fiche.titre": "Architecture decision",
  "v5.architecture.geste.erreur": "The action did not succeed. Try again in a moment.",
  "v5.architecture.heritage.col.categorie": "Category",
  "v5.architecture.heritage.col.ecart": "Difference",
  "v5.architecture.heritage.col.herite": "Inherited choice",
  "v5.architecture.heritage.col.origine": "Origin",
  "v5.architecture.heritage.col.projet": "Project choice",
  "v5.architecture.heritage.compte": "{{n}} difference(s) with inheritance.",
  "v5.architecture.heritage.ecart.different": "Different",
  "v5.architecture.heritage.ecart.identique": "Identical",
  "v5.architecture.heritage.ecart.projet_non_defini": "Missing from the project",
  "v5.architecture.heritage.ecart.sans_heritage": "No inheritance",
  "v5.architecture.heritage.libelle": "the comparison with inheritance",
  "v5.architecture.heritage.non_defini": "—",
  "v5.architecture.heritage.origine.aucune": "Own choice",
  "v5.architecture.heritage.origine.organisation": "Organisation",
  "v5.architecture.heritage.origine.programme": "Programme",
  "v5.architecture.heritage.source": "Inherited from",
  "v5.architecture.heritage.source.organisation": "Organisation ({{id}})",
  "v5.architecture.heritage.source.program": "Parent programme ({{id}}, version {{version}})",
  "v5.architecture.heritage.tableau": "Comparison with inherited choices",
  "v5.architecture.heritage.titre": "Compare inherited technology choices",
  "v5.architecture.heritage.version": "Compared version",
  "v5.architecture.heritage.version_courante": "Current project version ({{version}})",
  "v5.architecture.heritage.vide": "No technology category to compare.",
  "v5.architecture.liste.libelle": "the project decisions",
  "v5.architecture.liste.nouvelle": "New decision",
  "v5.architecture.liste.numero": "Decision",
  "v5.architecture.liste.option": "Chosen option",
  "v5.architecture.liste.statut": "Status",
  "v5.architecture.liste.technologies": "Technology choices and baseline",
  "v5.architecture.liste.titre": "Project architecture decisions",
  "v5.architecture.liste.vide": "No architecture decision in this project.",
  "v5.architecture.onglet.outil": "Tool",
  "v5.architecture.onglet.projet": "Project",
  "v5.architecture.onglets.decisions": "Decision scope",
  "v5.architecture.outil.contexte": "Context",
  "v5.architecture.outil.decision": "Decision",
  "v5.architecture.outil.fiche_libelle": "the tool decision",
  "v5.architecture.outil.fiche_titre": "Tool decision",
  "v5.architecture.outil.libelle": "the tool decisions",
  "v5.architecture.outil.options": "Options",
  "v5.architecture.outil.portee": "Read only: tool decisions are administered from the platform.",
  "v5.architecture.outil.retenue": "{{option}} (chosen)",
  "v5.architecture.outil.retour": "Back to the tool decisions",
  "v5.architecture.outil.sans_decision": "Not decided yet.",
  "v5.architecture.outil.titre": "Tool decisions",
  "v5.architecture.outil.vide": "No tool decision is published.",
  "v5.architecture.personne.inconnue": "a project member",
  "v5.architecture.pile.adr": "Decided by {{adr}}",
  "v5.architecture.pile.libelle": "the stack profile",
  "v5.architecture.pile.qualification": "Qualification: {{etat}}",
  "v5.architecture.pile.retenu": "Chosen stack: {{pile}}",
  "v5.architecture.pile.source.baseline": "Source: project technology baseline",
  "v5.architecture.pile.source.stack_profile": "Source: stack decision",
  "v5.architecture.pile.titre": "Project stack profile",
  "v5.architecture.pile.vide": "No stack profile chosen for this project.",
  "v5.architecture.remplacer.aucune": "No other decided decision of the project can replace it.",
  "v5.architecture.remplacer.bouton": "Confirm the replacement",
  "v5.architecture.remplacer.choisir": "Choose a decision",
  "v5.architecture.remplacer.libelle": "the project decisions",
  "v5.architecture.remplacer.remplacante": "Replacing decision",
  "v5.architecture.remplacer.titre": "Replace an architecture decision",
  "v5.architecture.reprise.ajouter": "Add the rework item",
  "v5.architecture.reprise.ajouter_titre": "Add a rework item",
  "v5.architecture.reprise.changement": "Change {{ref}}",
  "v5.architecture.reprise.changement_libelle": "the technology change",
  "v5.architecture.reprise.element": "Related item",
  "v5.architecture.reprise.element_aucun": "None",
  "v5.architecture.reprise.elements_libelle": "the project items",
  "v5.architecture.reprise.ensemble": "The owner and the expected evidence go together.",
  "v5.architecture.reprise.ligne": "{{titre}} — {{statut}}",
  "v5.architecture.reprise.membres_libelle": "the project members",
  "v5.architecture.reprise.non_regression": "Non-regression statement",
  "v5.architecture.reprise.panneau": "Rework items and evidence",
  "v5.architecture.reprise.partie": "You authored or own a rework item of this change: a third party validates it.",
  "v5.architecture.reprise.preuve_attendue": "Expected evidence",
  "v5.architecture.reprise.preuve_de": "Expected evidence: {{preuve}}",
  "v5.architecture.reprise.preuve_fournie": "Evidence provided for “{{titre}}”",
  "v5.architecture.reprise.preuve_fournie_de": "Evidence provided: {{preuve}}",
  "v5.architecture.reprise.responsable": "Owner",
  "v5.architecture.reprise.responsable_aucun": "No owner",
  "v5.architecture.reprise.responsable_de": "Owner: {{nom}}",
  "v5.architecture.reprise.statut.done": "Done",
  "v5.architecture.reprise.statut.in_progress": "In progress",
  "v5.architecture.reprise.statut.in_review": "In review",
  "v5.architecture.reprise.statut.todo": "To do",
  "v5.architecture.reprise.tiers": "A third party, neither author nor owner of a rework item, validates.",
  "v5.architecture.reprise.travail": "Work to do",
  "v5.architecture.reprise.valider": "Validate the rework",
  "v5.architecture.reprise.verifier_titre": "Validate the rework by a third party",
  "v5.architecture.reprise.vide": "No rework item for this change.",
  "v5.architecture.retour_vue_projet": "Back to the project overview",
  "v5.architecture.revoir.approuver": "Approve",
  "v5.architecture.revoir.auteur": "The author does not review their own decision.",
  "v5.architecture.revoir.bouton": "Save the review",
  "v5.architecture.revoir.commentaire": "Review comment",
  "v5.architecture.revoir.commentaire_requis": "A rejection says why: comment required.",
  "v5.architecture.revoir.conclusion": "Review conclusion",
  "v5.architecture.revoir.precedentes": "Previous reviews (kept)",
  "v5.architecture.revoir.rejeter": "Reject",
  "v5.architecture.revoir.titre": "Review an architecture decision",
  "v5.architecture.sans_projet": "Choose a project to see its architecture and decisions.",
  "v5.architecture.statut.cancelled": "Cancelled",
  "v5.architecture.statut.decided": "Decided",
  "v5.architecture.statut.deprecated": "Deprecated",
  "v5.architecture.statut.en_relecture": "Under review",
  "v5.architecture.statut.proposed": "Being prepared",
  "v5.architecture.statut.superseded": "Superseded",
  "v5.architecture.sujet.database": "Database",
  "v5.architecture.sujet.engine": "Engine",
  "v5.architecture.sujet.irreversible": "Hard-to-reverse decision: write its consequences on the stack, engine or database in the context.",
  "v5.architecture.sujet.other": "Other",
  "v5.architecture.sujet.stack": "Stack",
  "v5.architecture.verdict.approve": "approved",
  "v5.architecture.verdict.reject": "rejected",
  "v5.architecture.version.api_confirmee": "Confirmed by the survey",
  "v5.architecture.version.api_non_confirmee": "Not confirmed",
  "v5.architecture.version.api_sans_releve": "No survey",
  "v5.architecture.version.api_vide": "No exposed API found.",
  "v5.architecture.version.aucun_service": "No service SBOM for this version.",
  "v5.architecture.version.choix_requis": "Several services: choose which one to download.",
  "v5.architecture.version.col.chemin": "Path",
  "v5.architecture.version.col.composant": "Component",
  "v5.architecture.version.col.contrat": "Contract",
  "v5.architecture.version.col.corrigee": "Fixed in",
  "v5.architecture.version.col.depend": "Depends on",
  "v5.architecture.version.col.dependance": "Dependency",
  "v5.architecture.version.col.gravite": "Severity",
  "v5.architecture.version.col.identifiant": "Identifier",
  "v5.architecture.version.col.methode": "Method",
  "v5.architecture.version.col.nature": "Kind",
  "v5.architecture.version.col.paquet": "Package",
  "v5.architecture.version.col.relation": "Relation",
  "v5.architecture.version.col.technologie": "Technology",
  "v5.architecture.version.col.utilisee_par": "Used by",
  "v5.architecture.version.col.version": "Version",
  "v5.architecture.version.composants_vide": "No component found for this version.",
  "v5.architecture.version.dependances_resume": "{{total}} dependencies: {{direct}} direct, {{transitive}} transitive, {{system}} system.",
  "v5.architecture.version.dependances_version": "Version dependencies",
  "v5.architecture.version.dependances_vide": "No dependency matches the filters.",
  "v5.architecture.version.entete": "Version {{version}} — {{titre}}",
  "v5.architecture.version.fiches_dependances": "Dependency records",
  "v5.architecture.version.libelle": "the version architecture",
  "v5.architecture.version.nom_contient": "Name contains",
  "v5.architecture.version.onglet.api": "API",
  "v5.architecture.version.onglet.composants": "Components",
  "v5.architecture.version.onglet.dependances": "Dependencies",
  "v5.architecture.version.onglet.vulnerabilites": "Vulnerabilities",
  "v5.architecture.version.onglets": "Version views",
  "v5.architecture.version.relation": "Relation",
  "v5.architecture.version.relation.direct": "Direct",
  "v5.architecture.version.relation.system": "System",
  "v5.architecture.version.relation.toutes": "All",
  "v5.architecture.version.relation.transitive": "Transitive",
  "v5.architecture.version.retour": "Back to the versions",
  "v5.architecture.version.revision_service": "SBOM revision and service",
  "v5.architecture.version.sans_composant": "—",
  "v5.architecture.version.sbom": "Download the SBOM",
  "v5.architecture.version.sbom_ok": "SBOM downloaded.",
  "v5.architecture.version.titre": "Architecture of a delivered version",
  "v5.architecture.version.vuln_non_analyse": "No vulnerability analysis recorded for this version.",
  "v5.architecture.version.vuln_vide": "No vulnerability found by the latest analysis."
}
